import React, {useEffect} from "react"
import {Deal, PaymentProvider, Checkout} from "@irati/types"
import {PerksPaymentSelectOption} from "@shared/payments/types"
import FormattedMessage from "@irati/utils/lang"
import {H2} from "@irati/ui/src/Typography"

import PaymentFormAdyen from "@irati-web/payments/src/components/PaymentForm"
import {getAdyenCallbackUrlForRedirect} from "../../../helpers/paymentRedirectUrls"

interface Props {
  deal: Deal,
  checkout: Checkout,
  paymentBreakdown: PerksPaymentSelectOption[],
  onComplete: () => any
}

const PaymentForm: React.FC<Props> = ({deal, paymentBreakdown, checkout, onComplete}) => {
  const adyenAmount = paymentBreakdown.find((t) => t.type === PaymentProvider.Adyen)?.amount || 0

  useEffect(() => {
    if (!adyenAmount) {
      // this form only handles outstanding adyen payments, if no outstanding, complete()
      onComplete()
    }
  }, [])

  return (
    <>
      {adyenAmount > 0 && (
        <>
          <H2 marginBottom={2}>
            <FormattedMessage id="perks.containers.paymentOrder.paymentOption.checkout" />
          </H2>
          <PaymentFormAdyen
            paymentOrder={checkout.paymentOrder}
            amount={adyenAmount}
            onComplete={onComplete}
            redirectReturnUrl={getAdyenCallbackUrlForRedirect(deal, checkout)} />
        </>
      )}
    </>
  )
}

export default PaymentForm
